import Page from "../page";
import TaskInfo from "../../components/task/task-info";

const TasksPage = () => {
  return (
    <Page>
      <TaskInfo />
    </Page>
  );
};

export default TasksPage;
